import { Examples } from "./Examples";
import { Guide } from "./Guide";
import { GuidesProvider } from "./Guide/useGuide";

export enum StepsEditorSidebarSection {
  Examples = "Examples",
  Guide = "Guide",
}

export default function StepsEditorSidebar({
  trackingContext,
  activeSection,
  examplesPath,
}: {
  trackingContext: {
    organizationUuid: string;
  };
  activeSection: StepsEditorSidebarSection;
  examplesPath: string;
}) {
  switch (activeSection) {
    case StepsEditorSidebarSection.Guide:
      return (
        <GuidesProvider trackingContext={trackingContext}>
          <Guide />
        </GuidesProvider>
      );
    case StepsEditorSidebarSection.Examples:
      return <Examples examplesPath={examplesPath} />;
  }
}
